var map = {
	"./auth/en.json": 778,
	"./auth/vi.json": 779,
	"./common/en.json": 780,
	"./common/vi.json": 781,
	"./title/en.json": 782,
	"./title/vi.json": 783,
	"./user/en.json": 784,
	"./user/vi.json": 785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 777;